import api from "../services/api";

const userService = {
  userLogin: async (payload) => {
    try {
      const response = await api.post(`/users/login`, payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  userSignup: async (payload) => {
    try {
      const response = await api.post(`/users/signup`, payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  verifyOtp: async (payload) => {
    try {
      const response = await api.post(`/users/verify_otp`, payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  verifyForgetOtp: async (payload) => {
    try {
      const response = await api.post(`/users/verify-forget-otp`, payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  forgotPassword: async (payload) => {
    try {
      const response = await api.post(`/users/forget_password`, payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  resendOtp: async (payload) => {
    try {
      const response = await api.post(`/users/resend-otp`, payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  resetPassword: async (payload) => {
    try {
      const response = await api.post(`/users/reset_password`, payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  allStates: async () => {
    try {
      const response = await api.get(`state/getAllState`);
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || error.message;
    }
  },

  allLga: async (stateId) => {
    try {
      const response = await api.get(`state/getProvincesByStateId/${stateId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || error.message;
    }
  },

  // Polling units aren't stored locally — fetched live per ward through the
  // backend's INEC proxy (see backend/src/state/state.service.ts).
  getPollingUnits: async (wardId) => {
    try {
      const response = await api.get(`state/polling-units/${wardId}`);
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || error.message;
    }
  },

  getRoles: async () => {
    try {
      const response = await api.get(`role`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || error.message;
    }
  },
};

export default userService;